import React from 'react'
import { Query } from 'react-apollo'
import { Loader } from 'stylist'
import { Mutation } from 'react-apollo'
import Show from './Show'
import findValue from 'utils/findValue'

const BelongsTo = ({
  variables,
  query,
  history,
  removeMutation,
  removeMutationArgs = {},
  namespace,
  ...props
}) => (
  <Query query={query} variables={variables}>
    {({ loading, data }) => {
      if (loading) {
        return <Loader size="lg" centered />
      }

      return (
        <Mutation mutation={removeMutation}>
          {mutate => (
            <Show
              data={findValue(data, namespace)}
              onRemove={(e, row) => mutate(removeMutationArgs)}
              {...props}
            />
          )}
        </Mutation>
      )
    }}
  </Query>
)

export default BelongsTo



// WEBPACK FOOTER //
// ./src/components/BelongsTo/index.js